import { BaseMobileService } from './base-mobile.service';
import { logger } from '@/helpers/log.service';

class AndroidPermissionsService extends BaseMobileService {
  constructor() {
    super('cordova.plugins.permissions', 'AndroidPermissionsService');
  }

  public requestPermission(permission: string): Promise<boolean> {
    const msg = `[${this.serviceName}:requestPermission]`;

    return this.execute('requestPermission', null,
      (resolve: (p: boolean) => {}, _: () => {}, status: PermissionStatus) => {
        logger.debug(`${msg} result:`, status);
        resolve(status.hasPermission);
      },
      (resolve: (p: boolean) => {}, _: () => {}, err: any) => {
        logger.warn(`${msg} error:`, err);
        resolve(false);
      },
      permission) as Promise<boolean>;
  }

  public checkPermission(permission: string): Promise<boolean> {
    const msg = `[${this.serviceName}:checkPermission]`;

    return this.execute('checkPermission', null,
      (resolve: (p: boolean) => {}, _: () => {}, status: PermissionStatus) => {
        logger.debug(`${msg} result:`, status);
        resolve(status.hasPermission);
      },
      (resolve: (p: boolean) => {}, _: () => {}, err: any) => {
        logger.warn(`${msg} error:`, err);
        resolve(false);
      },
      permission) as Promise<boolean>;
  }

  public async requestNotificationPermission(): Promise<boolean> {
    const msg = `[${this.serviceName}:requestNotificationPermission]`;

    let permission = this.getServiceInstance()['POST_NOTIFICATIONS'];

    let hasPermission = await this.checkPermission(permission);

    if (!hasPermission) {
      hasPermission = await this.requestPermission(permission);
    }

    logger.debug(`${msg} permission ${permission} granted = ${hasPermission}`);

    return hasPermission;
  }
}

interface PermissionStatus {
  hasPermission: boolean;
}

export default new AndroidPermissionsService();
